module.exports = __webpack_public_path__ + "media/app/components/CategoryNav/iconsNewDesign/121.fdbda353.svg";